import { useEffect, useState } from 'react';
import { DBUserMessageThunks } from '@common-reducers/DBServiceThunks';
import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import type { UserMessage } from '@bt-common/schemas/bt/user-message';
import { fetchLazyThumbnail, isThumbnailOmitted, peekThumbnail } from '@common/services/lazy-thumbnail';

/** Returns `inline` when the row has its thumbnail, otherwise fetches the stored one by id (#270). */
export const useLazyThumbnail = (
    id: string | undefined,
    row: { linkPreview?: unknown; hasThumbnail?: boolean } | null | undefined,
    inline: string | undefined,
): string | undefined => {
    const dispatch = useAppDispatch();
    const needed = !!id && !inline && isThumbnailOmitted(row);
    const [fetched, setFetched] = useState<string | undefined>(() => (needed && id ? peekThumbnail(id) : undefined));
    useEffect(() => {
        if (!needed || !id) return;
        let alive = true;
        void fetchLazyThumbnail(id, async (docId) =>
            (await dispatch(DBUserMessageThunks.find({ _id: docId, $paginate: false } as never)).unwrap()) as UserMessage[] | undefined,
        ).then((t) => { if (alive && t) setFetched(t); });
        return () => { alive = false; };
    }, [needed, id, dispatch]);
    return inline || (needed ? fetched : undefined);
};
